export const FarmConstants = () => {

    return ({
        QUOTE1: "Only Farm Fresh Quality Can be Traded Here . !",
        QUOTE2: "Best Place To Buy Or Sell Commodities Across The Global",
        LOGO_URL: "../assets/farm-trade-logo.png",


    });
}